import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/pro-light-svg-icons';

const MinusIcon = ({ className = '', ...rest }) => {
  return <FontAwesomeIcon icon={faMinus} {...rest} className={className} />;
};

export default MinusIcon;
